module.exports = __webpack_public_path__ + "static/media/21.5c6b739b.jpg";